import React, { useState, useEffect } from "react";
import CompanyDropDown from "../../crm/CompanyDropDown";

export default function CompanySearch({ url }) {
  const handleChange = company_id => {
    if (!company_id) return;
    window.location = url + "?company_id=" + company_id;
  };

  return <CompanyDropDown onChange={company_id => handleChange(company_id)} />;
}
